import React from 'react';
import { useFormContext } from 'react-hook-form';
import { connect, useDispatch } from 'react-redux';

import { OnlyContinueButton } from 'components/base/BottomStepComponent';
import ContentSections from 'components/base/ContentSections';
import CustomSwitchButton from 'components/base/CustomSwitchButton';
import CustomTitleWithInput from 'components/base/CustomTitleWithInput';
import { MIN_WIDTH, SPACE_BETWEEN } from 'components/base/ItemTypeSet';
import Loading from 'components/base/Loading';
import { CustomTitleWithDropDown } from 'components/customer/CustomTitleWithDropDown';
import { CustomTitleLabel } from 'components/earning/CustomBaseComponments';
import { MessageChannelConfig } from 'components/message/CreateMessageConfig';
import {
  allSmsTip,
  allWhatsappTip,
  allWechatTip,
  inboxTip,
} from 'components/message/CreateMessageStepOne';
import MessageChannelCard from 'components/message/MessageChannelCard';
import { APIStatus, LanguageConfig, MessageChannel } from 'config/CustomEnums';
import { validate } from 'containers/engagement/message/CreateMessageValidate';

import { getScrollbarWidth, useMainContentWidth } from 'utils/ScreenUtil';

const mapPropsToState = (state) => ({
  status: state.createMessage.createStatus,
  message: state.createMessage.message,
  languages: state.language.allList,
});

function CreateMessageStepOne({ status, message, languages }) {
  const dispatch = useDispatch();
  const mainContentWidth = useMainContentWidth();
  const fullContainerWith = mainContentWidth - 80 - 60 - getScrollbarWidth();

  const { watch, setValue, getValues, setError, formState, clearErrors } =
    useFormContext();
  const { errors } = formState;

  const channelsField = 'channels';
  const channels = watch(channelsField);

  const nameField = 'name';
  const name = watch(nameField);

  const updateMessageStep = (selectedChannels) => {
    console.log('selectedChannels', selectedChannels);
    dispatch({
      type: 'createMessage/updateStepConfig',
      payload: {
        selectedChannels: selectedChannels,
        isSystemMessage: true,
      },
    });
  };

  React.useEffect(() => {
    updateMessageStep(channels);
  }, [channels]);

  const stepChangeAction = () => {
    const isValid = validate({
      getValues: getValues,
      setError,
      clearErrors,
      step: 0,
      isBack: false,
    });
    dispatch({
      type: 'createMessage/stepChange',
      payload: {
        isBack: false,
        step: 0,
        isValid,
      },
    });
  };

  const sections = [
    <>
      {status === APIStatus.calling ? (
        <Loading />
      ) : (
        <div>
          <CustomTitleWithInput
            title={'Name'}
            tips={
              'Only for CMS name display only, will not show in the message to be sent out.'
            }
            customTitleClass={'create-section-label-no-top-space'}
            error={errors?.name ? { error: true, ...errors.name } : {}}
            useDefaultValue={true}
            defaultValue={name}
            setValue={(value) => {
              setValue(nameField, value, { shouldDirty: true });
            }}
          />
          <div>
            <CustomTitleLabel title={'Message channel'} />
            <div
              className="step-type-area"
              style={{
                justifyContent:
                  fullContainerWith < (MIN_WIDTH + SPACE_BETWEEN) * 2
                    ? 'center'
                    : 'flex-start',
              }}
            >
              {MessageChannelConfig.map((channel) => {
                let alwaysShowTip = null;
                let toolTip = null;
                if (channel.channel === MessageChannel.inbox) {
                  // inbox card tip
                  if (channels.includes(MessageChannel.inbox)) {
                    if (channels?.length > 1) {
                      toolTip = inboxTip;
                    } else {
                      // only inbox, no tip
                    }
                  } else if (
                    !channels.includes(MessageChannel.all) &&
                    !channels.includes(MessageChannel.allWhatsapp) &&
                    !channels.includes(MessageChannel.allWechat)
                  ) {
                    if (channels?.length > 0) {
                      alwaysShowTip = inboxTip;
                    } else {
                      // no channels, no tip
                    }
                  }
                } else if (channel.channel === MessageChannel.all) {
                  // all card tip
                  toolTip = allSmsTip;
                } else if (channel.channel === MessageChannel.allWhatsapp) {
                  // all card tip
                  toolTip = allWhatsappTip;
                } else if (channel.channel === MessageChannel.allWechat) {
                  // all card tip
                  toolTip = allWechatTip;
                }

                return (
                  <MessageChannelCard
                    key={channel.channel}
                    channelConfig={channel}
                    selectedChannels={channels}
                    selected={channels?.includes(channel.channel)}
                    alwaysShowTip={alwaysShowTip}
                    toolTip={toolTip}
                    select={(channel) => {}}
                    unSelect={(channel) => {}}
                    disabled={true}
                  />
                );
              })}
            </div>
          </div>
        </div>
      )}
    </>,
  ];

  return (
    <>
      <ContentSections sections={sections} hidePreview={true} />
      <OnlyContinueButton
        disabledContinue={channels.length === 0}
        continueAction={() => {
          stepChangeAction();
        }}
      />
    </>
  );
}

export default connect(mapPropsToState)(CreateMessageStepOne);
